import type * as React from "react";

import classNames from "classnames";
import { useMemo } from "react";

import { TooltipOnOverflow } from "../TooltipOnOverflow";
import { type TTypographyVariant, Typography } from "../Typography";
import { useStyles } from "./styles";

type TProps = {
  body?: React.ReactNode;
  bodyTooltipOnOverflow?: boolean;
  maxWidth?: number;
  size?: "large" | "medium" | "small";
  title?: React.ReactNode;
};

export const TitleBody: FC<TProps> = ({
  body,
  bodyTooltipOnOverflow,
  className,
  maxWidth,
  ref,
  size = "medium",
  title,
  ...restProps
}) => {
  const classes = useStyles({ maxWidth, size });

  const [titleVariant, bodyVariant]: [TTypographyVariant, TTypographyVariant] = useMemo(() => {
    switch (size) {
      case "large":
        return ["title_sb", "body_reg"];
      case "medium":
        return ["body_sb", "body_reg"];
      case "small":
        return ["text_sm_sb", "text_sm_reg"];
    }
  }, [size]);

  return (
    <div {...restProps} className={classNames(classes.container, className)} ref={ref}>
      {title ? <Typography variant={titleVariant}>{title}</Typography> : null}

      {body
        ? (
            bodyTooltipOnOverflow
              ? (
                  <TooltipOnOverflow className={classes.body} content={body} textVariant={bodyVariant} />
                )
              : (
                  <Typography className={classes.body} variant={bodyVariant}>
                    {body}
                  </Typography>
                )
          )
        : null}
    </div>
  );
};
